import { ServiceType } from '@/shared/api/protocol-ts/api/billing_new/dto_services_new_pb';

import { DiagnocoinFunding, DiagnocoinFundingContext } from '../config';

export const getDiagnocoinFunding = (
  serviceTypes: readonly ServiceType[],
  context: DiagnocoinFundingContext,
): DiagnocoinFunding => {
  const { services, prices, available, hasCoinSpendableSubscription, isReady } =
    context;

  if (serviceTypes.length === 0) {
    return { source: 'unavailable' };
  }

  if (serviceTypes.some((serviceType) => services[serviceType])) {
    return { source: 'included' };
  }

  if (!isReady || !hasCoinSpendableSubscription) {
    return { source: 'unavailable' };
  }

  const affordable = serviceTypes
    .map((serviceType) => prices[serviceType])
    .filter(
      (price): price is number => price !== undefined && price <= available,
    );

  if (affordable.length === 0) {
    return { source: 'unavailable' };
  }

  const cheapest = Math.min(...affordable);

  return {
    source: 'diagnocoins',
    coins: cheapest,
    isMinimum: affordable.some((price) => price !== cheapest),
  };
};
